const b = "cookie_consent";
function S(e) {
  const t = e.split(";").map((r) => r.split("=").map((d) => d.trim())).find(([r]) => r === b);
  if (!t)
    return null;
  const [, c] = t;
  return c !== "0" && c !== "1" ? (console.warn("cookie_consent: unexpected cookie value"), null) : c;
}
let y = !1;
const k = "cookie-consent:accepted";
function z() {
  return L(T());
}
function I(e) {
  y && console.warn(
    "already called whenAllowed on cookie-consent, did you initialize google analytics twice ?"
  ), z() ? (m("whenAllowed, has consent"), e()) : (m("whenAllowed, has not consent, wait"), y = !0, window.addEventListener(k, () => {
    m("consent accepted"), e();
  }));
}
function L(e) {
  return e === "1";
}
function m(e) {
  var t;
  (t = window == null ? void 0 : window.config) != null && t.cookie_consent_debug && console.log(`cookie-consent: ${e}`);
}
function T() {
  return S(document.cookie);
}
function x(e) {
  return e.isAuthenticated && e.roles.includes("teacher");
}
function R(e) {
  return e.isAuthenticated && e.trialState === "NORMAL_USER" && e.roles.includes("student");
}
function $(e, t) {
  const c = e.split(";").map((p) => p.split("=").map((w) => w.trim())).find(([p]) => p === t);
  if (!c)
    return !1;
  const [, r] = c;
  if (r !== "false" && r !== "true")
    return console.warn(`${t}: unexpected cookie value`), !1;
  const d = r === "true";
  return d && console.log(`${t} enabled`), d;
}
function C() {
  const e = $(document.cookie, "ga4_debug"), t = $(document.cookie, "ga4_trace");
  return { debug: e, trace: t };
}
function A(e) {
  if (typeof window > "u" || typeof document > "u")
    return;
  const t = document.createElement("script");
  t.async = !0, t.onerror = () => {
    console.error("Failed to load the GA4 script");
  }, t.src = `https://www.googletagmanager.com/gtag/js?id=${e}`, document.body.appendChild(t), window.dataLayer = window.dataLayer || [], window.gtag = function() {
    window.dataLayer.push(arguments);
  };
}
function g(e, ...t) {
  if (!window.gtag) {
    console.error("gtag is not defined");
    return;
  }
  window.gtag(e, ...t);
}
function G(e, t) {
  if (!e)
    throw new Error("Require GA_MEASUREMENT_ID");
  A(e), g("js", /* @__PURE__ */ new Date()), g("consent", "default", {
    ad_storage: "denied",
    // denies permission to use cookies or other storage that is used for advertising purposes.
    ad_user_data: "denied",
    // denies permission to use data for advertising purposes.
    ad_personalization: "denied",
    // denies permission to use cookies or other storage that is used for advertising purposes.
    analytics_storage: "granted",
    // grants permission to use data for analytics purposes.
    functionality_storage: "denied",
    // denies permission to store data that is necessary for providing functionality that the user has explicitly requested.
    personalization_storage: "denied",
    // denies permission to store information that could be used to personalize content or ads on the site or across sites.
    security_storage: "granted"
    // grants permission to use data for ensuring security, preventing fraud, and debugging.
  }), g("config", e, {
    ...t
  });
}
const h = () => ({
  initialized: !1,
  debug: !1,
  trace: !1,
  appName: "unknown",
  gaMeasurementId: "",
  schoolType: "",
  userId: "",
  userRole: "",
  userTrial: "",
  env: ""
});
function M(e) {
  if (e.env)
    return e.env;
  const { host: t } = window.location;
  return t === "gleerupsportal.se" ? "prod" : t === "stage.eedev.se" ? "stage" : t === "chi.eedev.se" ? "chi" : "dev";
}
const V = {
  dev: "",
  chi: "G-LC9PSYEXJY",
  stage: "G-66D873MRQJ",
  prod: "G-XT26MXHLY4"
};
function j(e) {
  return x(e) ? "teacher" : R(e) ? "student" : e.roles[0] || "unknown";
}
function U() {
  const e = h();
  function t(n, o) {
    e.trace && (o ? console.log(`analytics ${e.appName}: ${n}`, o) : console.log(`analytics ${e.appName}: ${n}`));
  }
  function c(n) {
    if (e.initialized) {
      t("analytics.init already initialized");
      return;
    }
    const { debug: o, trace: a } = C();
    e.debug = o || n.debug || !1, e.trace = a || n.trace || !1, e.appName = n.appName;
    const l = M(n);
    if (e.env = l, e.gaMeasurementId = V[l], !e.gaMeasurementId) {
      t("missing gaMeasurementId, skip google analytics");
      return;
    }
    t("analytics.init, wait for cookie consent"), I(() => {
      if (e.initialized) {
        t("analytics.init already initialized after cookie approve");
        return;
      }
      t("analytics.init calling");
      const s = {
        cookie_flags: "SameSite=Lax",
        // see CONX-1435
        ...e.debug ? { debug_mode: !0 } : {}
      };
      G(e.gaMeasurementId, s), e.initialized = !0, t("analytics.init done");
    });
  }
  function r(n) {
    if (!e.initialized) {
      t("setUser: not initialized, skipping (dev mode?)");
      return;
    }
    const o = j(n), a = n.trialState.toLowerCase();
    e.userId === n.userId && e.userRole === o && e.userTrial === a || (t(`setUser id: "${n.userId}" role: "${o}" trial: "${a}"`), g("set", "user_properties", {
      user_role: o,
      user_id: n.userId,
      user_trial: a
    }), e.userId = n.userId, e.userRole = o, e.userTrial = a);
  }
  function d(n) {
    if (e.schoolType !== n) {
      if (!e.initialized) {
        t("setSchoolType: not initialized, skipping (dev mode?)");
        return;
      }
      t(`setSchoolType: "${n}", (prev: "${e.schoolType}")`), g("set", "user_properties", { user_school_type: n }), e.schoolType = n;
    }
  }
  function p(n) {
    const a = /^\S*$/, l = /^[_a-z0-9.]*$/;
    let s = !0;
    const v = ["action", "category", "label"];
    return Object.entries(n).forEach(([f, u]) => {
      if (v.includes(f)) {
        if (!(u != null && u.length)) {
          f !== "label" && (console.warn(`Value of '${f}' is missing`, n), s = !1);
          return;
        }
        if (u.length > 40 && (console.warn(
          `Value of '${f}' exceeds maximum length of 40 characters.`,
          n
        ), s = !1), !a.test(u)) {
          console.warn(`Value of '${f}' contains whitespace ('${u}')`, n), s = !1;
          return;
        }
        l.test(u) || (console.warn(
          `Value of '${f}' is not lowercase or invalid character ('${u}')`,
          n
        ), s = !1);
      }
    }), s;
  }
  function w(n) {
    if (!e.initialized) {
      t("event: not initialized, skipping (dev mode?)");
      return;
    }
    if (!p(n))
      return;
    const { action: o } = n, a = Object.fromEntries(
      Object.entries(n).filter(([l]) => l !== "action").map(([l, s]) => [`event_${l}`, s])
    );
    t(`send ga event: "${o}"`, n), g("event", o, a);
  }
  function _() {
    Object.assign(e, h());
  }
  return {
    init: c,
    event: w,
    setUser: r,
    setSchoolType: d,
    getState: () => e,
    reset: _
  };
}
let i = null;
const E = {
  init: (e) => {
    if (i) {
      console.warn(`analytics already initialized (${i.getState().appName})`);
      return;
    }
    try {
      i = U(), i.init(e);
    } catch (t) {
      console.error("Can't init Google analytics", t), i = null;
    }
  },
  reset: () => {
    i && (i.reset(), i = null);
  },
  event: (e) => {
    i && i.event(e);
  },
  setUser: (e) => {
    i && i.setUser(e);
  },
  setSchoolType: (e) => {
    i && i.setSchoolType(e);
  },
  getState: () => (i == null ? void 0 : i.getState()) || h(),
  getInstance: () => i,
  setInstance: (e) => {
    if (!e)
      return;
    const t = e.getState();
    t.trace && console.log(`analytics setInstance ${t.appName}`), i = e;
  }
};
export {
  E as analytics,
  M as getEnvironment
};
//# sourceMappingURL=index.js.map
